import React, { Component } from 'react';
import { Box, TextField } from '@mui/material';

class AppPriceInput extends Component {
    constructor(props) {
        super(props);

        this.lastValidValue =
            props.initialValue != null
                ? props.initialValue
                : props.minPrice != null
                    ? props.minPrice.toFixed(2).replace('.', ',')
                    : '0';
    }

    getRangeMessage = (minPrice, maxPrice) => {
        if (minPrice != null && maxPrice != null) {
            return `Bitte einen Wert zwischen ${minPrice} und ${maxPrice} eingeben.`;
        }

        if (minPrice != null) {
            return `Bitte mindestens ${minPrice} eingeben.`;
        }

        if (maxPrice != null) {
            return `Bitte höchstens ${maxPrice} eingeben.`;
        }

        return 'Bitte einen gültigen Wert eingeben.';
    };

    onEndEditing = () => {
        const { value, minPrice, maxPrice, setValue, disabled } = this.props;

        if (disabled) {
            return;
        }

        if (!value) {
            setValue?.(this.lastValidValue, true);
            return;
        }

        const numericValue = parseFloat(String(value).replace(',', '.'));

        if (isNaN(numericValue)) {
            setValue?.(this.lastValidValue, true);
            return;
        }

        if (numericValue <= 0) {
            window.alert('Es sind nur positive Zahlen erlaubt.');
            setValue?.(this.lastValidValue, true);
            return;
        }

        if (minPrice != null && numericValue < minPrice) {
            const fixed = minPrice.toFixed(2).replace('.', ',');
            setValue?.(fixed, true);
            window.alert(this.getRangeMessage(minPrice, maxPrice));
            return;
        }

        if (maxPrice != null && numericValue > maxPrice) {
            const fixed = maxPrice.toFixed(2).replace('.', ',');
            setValue?.(fixed, true);
            window.alert(this.getRangeMessage(minPrice, maxPrice));
            return;
        }

        const fixed = numericValue.toFixed(2).replace('.', ',');
        this.lastValidValue = fixed;
        setValue?.(fixed, true);
    };

    render() {
        const {
            value,
            setValue,
            maxLength,
            textInputProps = {},
            placeholder,
            style,
            disabled,
            ...rest
        } = this.props;

        return (
            <Box>
                <TextField
                    fullWidth
                    size="small"
                    disabled={disabled}
                    value={value != null ? String(value).replace('.', ',') : ''}
                    placeholder={placeholder ?? textInputProps.placeholder ?? 'Wert'}
                    onFocus={() => setValue?.('')}
                    onChange={(e) => setValue?.(e.target.value)}
                    onBlur={this.onEndEditing}
                    inputProps={{
                        maxLength: maxLength ?? 6,
                        inputMode: 'decimal',
                        ...textInputProps.inputProps,
                    }}
                    sx={{
                        '& .MuiInputBase-root': {
                            minHeight: 40,
                        },
                        ...style,
                    }}
                    {...textInputProps}
                    {...rest}
                />
            </Box>
        );
    }
}

export default AppPriceInput;